class AtomAESWebCrypto {
  // Generate key using PBKDF2 (matches PHP's openssl_pbkdf2)
  static async generateKey(key, salt) {
    try {
      const encoder = new TextEncoder();
      
      // Import the raw key material
      const keyMaterial = await window.crypto.subtle.importKey(
        'raw',
        encoder.encode(key),
        'PBKDF2',
        false,
        ['deriveBits', 'deriveKey']
      );

      // Derive the AES key using PBKDF2
      const derivedKey = await window.crypto.subtle.deriveKey(
        {
          name: 'PBKDF2',
          salt: encoder.encode(salt),
          iterations: 65536,
          hash: 'SHA-1'
        },
        keyMaterial,
        { name: 'AES-CBC', length: 256 },
        false,
        ['encrypt', 'decrypt']
      );

      return derivedKey;
    } catch (error) {
      console.error('Key generation error:', error);
      throw new Error('Failed to generate encryption key');
    }
  }

  // Encrypt function
  static async encrypt(data, key, salt) {
    if (!key || !data || !salt) {
      return "String to encrypt, Salt and Key is required.";
    }

    try {
      const derivedKey = await this.generateKey(key, salt);
      
      // Create IV from fixed array (matches PHP implementation)
      const iv = new Uint8Array([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15]);
      const encoder = new TextEncoder();
      
      // Encrypt the data
      const encrypted = await window.crypto.subtle.encrypt(
        {
          name: 'AES-CBC',
          iv: iv
        },
        derivedKey,
        encoder.encode(data)
      );

      // Convert to hex string (matches PHP's bin2hex)
      const encryptedArray = new Uint8Array(encrypted);
      return Array.from(encryptedArray)
        .map(b => b.toString(16).padStart(2, '0'))
        .join('');
        
    } catch (error) {
      console.error('Encryption error:', error);
      return "Encryption failed.";
    }
  }

  // Decrypt function
  static async decrypt(data, key, salt) {
    if (!key || !data || !salt) {
      return "Encrypted String to decrypt, Salt and Key is required.";
    }

    try {
      const derivedKey = await this.generateKey(key, salt);
      
      // Create IV from fixed array
      const iv = new Uint8Array([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15]);
      
      // Convert hex string back to bytes
      const encryptedData = new Uint8Array(
        data.match(/.{1,2}/g).map(byte => parseInt(byte, 16))
      );
      
      // Decrypt the data
      const decrypted = await window.crypto.subtle.decrypt(
        {
          name: 'AES-CBC',
          iv: iv
        },
        derivedKey,
        encryptedData
      );

      // Convert back to string
      return new TextDecoder().decode(decrypted);
      
    } catch (error) {
      console.error('Decryption error:', error);
      return "Decryption failed.";
    }
  }
}

export default AtomAESWebCrypto;